/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if(boostSDAppConfig) {
   boostSDAppConfig.analytics = {
  selectorAddToCart: '.boost-sd__btn-add-to-cart, form[action="/cart/add"] *[type="submit"], form[action="/cart/add"] *[name="add"], .product-details__add-to-cart-button'
};
}